import { gql } from '@apollo/client';

export const GET_CONNECTIONS = gql`
  query getClientConnections($clientId: ID!) {
    client(id: $clientId) {
      id
      financialConnections {
        id
        financialInstitutionName
        state
        source
        institutionId
        isSyncing
        sourceId
        earliestSyncDate
        accounts {
          id
          name
          isPersonal
          isActive
          number
          type
          sourceId
          defaultCurrency
          isMultiCurrency
          isRemovedFromSource
          clientUsageType
          sourceSyncDateTime
          balances(limit: 1, sortDesc: true) {
            data {
              amount
              sourceSyncTime
            }
          }
          ledger {
            id
            name
            role
            latestValidBalance: balances(limit: 1, sortDesc: true, status: "VALID") {
              date
              amount
            }
            latestInvalidBalance: balances(limit: 1, sortDesc: true, status: "INVALID") {
              status
              date
              amount
            }
            referenceBalance: balances(limit: 1, sortDesc: true, status: "REFERENCE") {
              date
              amount
            }
          }
        }
      }
    }
  }
`;

export const GET_MIN_MAX_TRANSACTION_DATE = gql`
  query getMinMaxTransactionDate($clientId: ID!, $source: CollectionMethod!) {
    financialConnections(clientId: $clientId, source: $source) {
      id
      accounts {
        id
        latestTransactions: transactions(limit: 1, sortDesc: true) {
          data {
            date
          }
        }
        earliestTransactions: transactions(limit: 1, sortDesc: false) {
          data {
            date
          }
        }
      }
    }
  }
`;

export const GET_LEDGER_ACCOUNTS = gql`
  query getLedgerAccounts($clientId: ID!) {
    ledgerAccounts(clientId: $clientId, getFdsAccountIds: true) {
      active
      id
      name
      role
      accountSettings {
        fdsAccountId
      }
      category {
        id
      }
    }
  }
`;

export const UPDATE_LEDGER_MAPPING = gql`
  mutation mapConnectionToLedger($clientId: ID!, $connection: ConnectionInput!, $accountId: ID!) {
    mapConnectionToAccount(clientId: $clientId, connection: $connection, accountId: $accountId) {
      id
    }
  }
`;

export const UNMAP_LEDGER = gql`
  mutation unmapFDSAccountLedgerMapping($accountId: ID!, $ledgerId: ID, $dryRun: Boolean!) {
    updateAccountLedgerMapping(accountId: $accountId, ledgerId: $ledgerId, dryRun: $dryRun) {
      remappedAccounts {
        accountId
        oldLedgerId
        newLedgerId
      }
    }
  }
`;

export const UPDATE_USAGE_TYPE = gql`
  mutation updateFinancialDataAccountClientUsage(
    $input: UpdateFinancialDataAccountClientUsageInput!
  ) {
    updateFinancialDataAccountClientUsage(input: $input) {
      ... on FinancialDataAccountsResponse {
        accounts {
          id
          name
          clientUsageType
        }
      }
    }
  }
`;

export const RESET_CONNECTION = gql`
  mutation reset($connectionId: ID!) {
    resetConnection(connectionId: $connectionId) {
      id
      accounts {
        id
      }
    }
  }
`;

export const RESET_NEW_INTEGRATION = gql`
  mutation resetNewIntegration($connectionId: ID!) {
    resetNewIntegration(connectionId: $connectionId)
      @rest(
        type: "Connection"
        endpoint: "v2FinancialData"
        path: "/connection/:connectionId/reset?preserveAccounts=true"
      ) {
      NoResponse
    }
  }
`;

export const DELETE_CONNECTION = gql`
  mutation deleteConnection($connectionId: ID!) {
    deleteFinancialConnection(connectionId: $connectionId)
  }
`;

// This is a V2 mutation
export const DELETE_RUTTER_CONNECTION = gql`
  mutation DeleteRutterConnection($input: DeleteRutterConnectionInput!) {
    deleteRutterConnection(input: $input) {
      ... on DeleteRutterConnectionResponse {
        success
      }
    }
  }
`;

export const SYNC_CONNECTION = gql`
  mutation update($connectionId: ID!) {
    syncConnection(connectionId: $connectionId) {
      id
    }
  }
`;

export const SYNC_NEW_INTEGRATION_CONNECTION = gql`
  mutation syncNewIntegrationConnection(
    $type: String!
    $clientId: ID!
    $startDate: String!
    $endDate: String!
    $sourceId: String!
  ) {
    syncNewIntegrationConnection(
      type: $type
      clientId: $clientId
      startDate: $startDate
      endDate: $endDate
      sourceId: $sourceId
    )
      @rest(
        type: "Connection"
        endpoint: "v2FinancialData"
        path: "/:type/sync/:clientId?sourceId=:sourceId&startTime=:startDate&endTime=:endDate"
      ) {
      NoResponse
    }
  }
`;
